<template>
  <div>
    {{ actualServerTime }}
  </div>
</template>

<script>
import { get } from 'providers/http'
import moment from 'moment'

export default {
  name: 'system-time',
  data () {
    return {
      startingServerTime: null,
      startingBrowserTime: null,
      actualBrowserTime: null,
      timerId: null
    }
  },
  computed: {
    actualServerTime () {
      if (!this.startingServerTime) {
        return ''
      }

      const sst = this.startingServerTime.getTime()
      const sbt = this.startingBrowserTime.getTime()
      const abt = this.actualBrowserTime.getTime()

      const ast = sst + (abt - sbt)

      return moment(ast).format(this.$t('format.longDate'))
    }
  },
  beforeCreate () {
    get('api/v1/serverTime').then(({time}) => {
      this.startingServerTime = new Date(time)
      this.startingBrowserTime = new Date()
      this.actualBrowserTime = new Date()

      this.timerId = setInterval(() => {
        this.actualBrowserTime = new Date()
      }, 1000)
    })
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  }
}
</script>


// WEBPACK FOOTER //
// SystemTime.vue?36c5188f